import http from "./public";

var pub = "/api/web/userCenter/";

export const departPage = (params) => {
  //部门查询
  return http(`${pub}departPage`, params);
};
export const organization = (params) => {
  //部门查询
  return http(`${pub}organization`, params);
};
export const tisOrganization = (params) => {
  //TIS机构的组织架构
  return http(`${pub}tisOrganization`, params);
};
export const usersRoles = (params) => {
  //用户拥有的角色
  return http(`${pub}usersRoles`, params);
};

export const queryOrganizationByComId = (params) => {
  //部门查询
  return http(`/api/common/syscom/queryOrganizationByComId`, params);
};
export const companyInfo = (params) => {
  //获取企业信息
  return http(`/api/web/audit/companyInfo`, params);
};

export const myMenus = (params) => {
  //获取我的菜单
  return http(`${pub}myMenus`, params);
};
export const userMenus = (params) => {
  //获取用户的菜单
  return http(`${pub}userMenus`, params);
};

export const departCreate = (params) => {
  //部门新增
  return http(`${pub}departCreate`, params);
};
export const departEdit = (params) => {
  //部门修改
  return http(`${pub}departEdit`, params);
};
export const departDel = (params) => {
  //部门删除
  return http(`${pub}departDel`, params);
};

export const isRelationCenter = (params) => {
  //保险公司查询是否关联服务中心
  return http(`${pub}isRelationCenter`, params);
};

export const userCreate = (params) => {
  //用户创建
  return http(`${pub}userCreate`, params);
};
export const userCertificateEdit = (params) => {
  //修改用户证书信息
  return http(`${pub}userCertificateEdit`, params);
};
export const userPage = (params) => {
  //用户查询
  return http(`${pub}userPage`, params);
};
export const userDel = (params) => {
  //用户删除
  return http(`${pub}userDel`, params);
};

export const parentDepart = (params) => {
  //获取上级部门
  return http(`${pub}parentDepart`, params);
};
export const userEdit = (params) => {
  //用户修改
  return http(`${pub}userEdit`, params);
};
export const positionPage = (params) => {
  //岗位查询分页
  return http(`${pub}positionPage`, params);
};
export const positionCreate = (params) => {
  //岗位新增
  return http(`${pub}positionCreate`, params);
};
export const positionEdit = (params) => {
  //岗位修改
  return http(`${pub}positionEdit`, params);
};
export const positionDel = (params) => {
  //岗位删除
  return http(`${pub}positionDel`, params);
};

export const rolePage = (params) => {
  //角色查询分页
  return http(`${pub}rolePage`, params);
};
export const roleCreate = (params) => {
  //新增角色
  return http(`${pub}roleCreate`, params);
};
export const roleEdit = (params) => {
  //修改角色
  return http(`${pub}roleEdit`, params);
};

export const qeryInsureComEntryTisList = (params) => {
  //保险公司查询TIS机构分页列表
  return http(`${pub}qeryInsureComEntryTisList`, params);
};

export const addInsureComEntryTisDetail = (params) => {
  //保险公司查询TIS机构分页列表
  return http(`${pub}addInsureComEntryTisDetail`, params);
};

export const deleteInsureComEntryTisDetail = (params) => {
  //保险公司删除TIS机构信息详情
  return http(`${pub}deleteInsureComEntryTisDetail`, params);
};

export const queryInsureComEntryTisDetail = (params) => {
  //保险公司查询TIS机构信息详情
  return http(`${pub}queryInsureComEntryTisDetail`, params);
};
export const updateInsureComEntryTisDetail = (params) => {
  //保险公司修改TIS机构信息详情
  return http(`${pub}updateInsureComEntryTisDetail`, params);
};
/**
 * @description 验签获取用户token
 */
export const queryUserToken = (params) => {
  return http(`/api/out/tzauth/queryUserToken`, params);
};

/**
 * @description 主管部门查询保险公司列表
 */
export const govQueryInsureComList = (params) => {
  return http(`/api/web/government/govQueryInsureComList`, params);
};

/**
 * @description 主管部门查询保险公司详情
 */
export const govQueryInsureComDetail = (params) => {
  return http(`/api/web/government/govQueryInsureComDetail`, params);
};

/**
 * @description 主管部门录入保险公司信息
 */
export const govAddInsureComInfo = (params) => {
  return http(`/api/web/government/govAddInsureComInfo`, params);
};

/**
 * @description 主管部门修改保险公司信息
 */
export const govEditInsureComInfo = (params) => {
  return http(`/api/web/government/govEditInsureComInfo`, params);
};

/**
 * @description 保险公司删除TIS机构信息详情
 */
export const govDelInsureComInfo = (params) => {
  return http(`/api/web/government/govDelInsureComInfo`, params);
};
/**
 * @description 查询tis机构列表(主管部门)
 */
export const queryGovTisList = (params) => {
  return http(`/api/web/government/queryGovTisList`, params);
};
/**
 * @description 主管部门新增保险公司人脸库信息
 */
export const govRegisterInsureFaceGroup = (params) => {
  return http(`/api/web/government/govRegisterInsureFaceGroup`, params);
};
